import React from "react";
import { useTranslation } from "react-i18next";
import { AlertYellowIcon } from "@/shared/icons/AlertYellowIcon";
import type { ModalProps } from "antd/lib";
import { ModalWrapper } from "../ModalWrapper";
import styles from "./styles.module.scss";

export const ModalLogout: React.FC<ModalProps> = ({ ...props }) => {
  const { t } = useTranslation();

  const classNames = {
    wrapper: styles["modal-logout-wrapper"],
    mask: styles["modal-logout-mask"],
    body: styles["modal-logout-body"],
    content: styles["modal-logout-content"],
    footer: styles["modal-logout-footer"],
  };

  return (
    <ModalWrapper
      type="save"
      okText={t("common.logOut")}
      cancelText={t("common.cancel")}
      modalTitle={""}
      className={styles.root}
      classNames={classNames}
      width={400}
      {...props}
    >
      <>
        <AlertYellowIcon width={24} height={24} />
        <h4 className={styles["header-text"]}>{t("common.logoutModal")}</h4>
      </>
    </ModalWrapper>
  );
};
